import ResizeItemCommand from '../command/resizeItemCommand';
import CutangleItem from '../item/cutangleItem';
import DrillItem from '../item/drillItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class WidthField
 */
export default class WidthField extends LengthUnitField {
    type = 'width';
    supports = 'supportsWidth';

    /**
     * Update field value with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('width'));
    }

    /**
     * Update item value with field value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const width = this.getValue();
        const height = item.get('height');
        const position = item.get('position').clone();
        const history = this.editor.getCanvas().getHistory();

        this.assertItemValue(item, 'width', width);

        const command = new ResizeItemCommand(item, width, height, position);

        history.addAndExecuteCommand(command);
    }

    /**
     * Update item value with field value relative to a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const width = this.getValue() + difference;
        const height = item.get('height');
        const position = item.get('position').clone();
        const history = this.editor.getCanvas().getHistory();

        this.assertItemValue(item, 'width', width);

        const command = new ResizeItemCommand(item, width, height, position);

        history.addAndExecuteCommand(command);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength === 1
            && supportFlag
            && item
            && item[supportFlag]
            && !(item instanceof DrillItem)
            && !(item instanceof CutangleItem);
    }
}
